import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import ScrollTrigger from 'gsap/ScrollTrigger';

const FinancialPlanningSection = () => {
  const sectionRefFinancial = useRef(null);

  // Use useLayoutEffect to ensure the DOM is ready
  useGSAP(() => {
    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger);

    // GSAP scroll-triggered animation for .line elements
    gsap.from(sectionRefFinancial.current, {
      y: 100,         // Initial Y offset
      opacity: 0,     // Start with opacity 0
      duration: 1.5,    // Duration of the animation
      stagger: 0.1,   // Stagger delay between elements
      ease: "power3.out", // Easing for smoothness
      scrollTrigger: {
        trigger: "#financial-section",  // Trigger animation when this element comes into view
        start: "top 80%",  // Start when top of the section is at 80% of viewport height
      }
    });
  }, []);
  

  return (
    <section 
      // ref={sectionRefFinancial}
      className="w-full min-h-screen flex items-center justify-center bg-white pt-80 pb-32 light-section"
    >
      <div id='financial-section' className="w-full flex flex-col md:flex-row items-center justify-center gap-x-4">
        
        {/* Left Content */}
        <div ref={sectionRefFinancial}  className="animate-lines mx-auto">
          <h2 className="text-8xl font-bold text-black ml-20">
            <div className="">FINANCIAL</div>
            <div className=""><span className="text-[#457b9d]">PLANNING IS </span></div>
            <div className="">EASY NOW</div>
          </h2>
        </div>

        {/* Right Content */}
        <div className="max-w-6xl mx-auto md:w-1/3 mt-10 md:mt-0">
          <p className="text-2xl text-gray-800 mb-12 tracking-tight">
            From tuition fees to living expenses,<br />
            we help you plan your finances effectively, <br />
            ensuring a smooth transition to your new academic life. 
          </p>
          <a href='#about'
            className="bg-[#457b9d] text-white font-bold py-3 px-6 rounded-md shadow-md hover:bg-[#1d3557] hover:text-white transition-all duration-300"
          >
            SEE ALL ACTIVITIES
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinancialPlanningSection;
